import { Tag } from '@ekhodealer/ekho-common/rev';

import type { ConversationStatus } from '@ekhodealer/ekho-common';
import type { TagProps } from '@ekhodealer/ekho-common/rev';

import { CONVERSATION_STATUS_CONFIG } from './conversationStatusConfig';

interface ConversationStatusTagProps {
	/** Current conversation status to display. */
	status: ConversationStatus;
	/** Tag size variant. */
	size?: TagProps['size'];
}

export const ConversationStatusTag = ({ status, size = 'small' }: ConversationStatusTagProps): React.ReactNode => {
	const { label, accent } = CONVERSATION_STATUS_CONFIG[status];
	return (
		<Tag accent={accent} size={size}>
			{label}
		</Tag>
	);
};
